import React, { useEffect, useState, useRef } from "react";
import {
  Mic,
  Paperclip,
  Image as ImageIcon,
  Send,
  Printer,
  Star,
  Trash2,
  ChevronLeft,
  MoreVertical,
  X,
  File,
  Music,
  StopCircle,
} from "lucide-react";
import "../../styles/message.css";
import { useSelector } from "react-redux";
import {
  deleteWithTokenAPI,
  deleteWithTokenBodyAPI,
  getWithTokenAPI,
  ImageUpload,
  postWithTokenAPI,
} from "../../util/Api";
import {
  messages_create,
  messages_delete,
  messages_delete_multiple,
  messages_get,
  messages_pin,
  messages_unpin,
} from "../../util/Apiendpoits";
import { SafeToast } from "../Toast/ShowToast";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
const MessageComponent = () => {
  const { token, roleType, userId } = useSelector((state) => state.auth);
  const profile = useSelector((state) => state.profile);

  console.log(userId, "userIduserId");

  const [chatList, setChatList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  console.log(messages, "messagesmessages");
  const [content, setContent] = useState("");
  const [receiverdeatils, setReceiverdeatils] = useState();
  console.log(receiverdeatils, "receiverdeatils");
  const [activeChatId, setActiveChatId] = useState(null);

  // File upload states
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [isRecording, setIsRecording] = useState(false);
  const [audioBlob, setAudioBlob] = useState(null);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [showImagePreview, setShowImagePreview] = useState(false);
  const [showDocumentPreview, setShowDocumentPreview] = useState(false);
  const [recordingTime, setRecordingTime] = useState(0);
  const timerRef = React.useRef(null);
  const [openMenuId, setOpenMenuId] = useState(null);
  const messagesEndRef = useRef(null);
  const { id } = useParams()
  const { name } = useParams()

  console.log(id, "id============");


  useEffect(() => {
    setReceiverdeatils({
      user_id: id,
      user_name: name

    })
  }, [id])
  // Refs
  const fileInputRef = useRef(null);
  const imageInputRef = useRef(null);
  const audioChunks = useRef([]);

  const fetchChatList = async () => {
    try {
      const res = await getWithTokenAPI(token, `${messages_get}${userId}`);

      if (res?.data) {
        setChatList(res.data);
      }
    } catch (error) {
      console.error("Chat list error:", error);
    }
  };

  useEffect(() => {
    if (token && userId) {
      fetchChatList();
    }
  }, [token, userId, activeChatId]);

  const HandleParicliteChnage = async () => {
    try {
      const res = await getWithTokenAPI(
        token,
        `/messages/chat?user1=${userId}&user2=${receiverdeatils.user_id}`,
      );

      if (res?.data) {
        setMessages(res.data);
      }
    } catch (error) {
      console.error("Chat fetch error:", error);
    }
  };

  useEffect(() => {
    HandleParicliteChnage();
  }, [receiverdeatils]);

  const formatTime = (date) => {
    return new Date(date).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // Handle image selection
  const handleImageSelect = (e) => {
    const files = Array.from(e.target.files);

    // Filter only image files
    const imageFiles = files.filter(
      (file) => file.type.startsWith("image/") && file.size <= 5 * 1024 * 1024, // 5MB limit
    );

    if (imageFiles.length === 0) {
      SafeToast.error("Please select valid image files (max 5MB each)");
      return;
    }

    // Create preview URLs
    const newImages = imageFiles.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setSelectedImages((prev) => [...prev, ...newImages]);
    setShowImagePreview(true);
  };

  // Handle document selection
  const handleDocumentSelect = (e) => {
    const files = Array.from(e.target.files);

    // Allowed document types
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/plain",
    ];

    const docFiles = files.filter(
      (file) =>
        allowedTypes.includes(file.type) && file.size <= 10 * 1024 * 1024, // 10MB limit
    );

    if (docFiles.length === 0) {
      SafeToast.error(
        "Please select valid document files (PDF, Word, Excel, TXT) max 10MB",
      );
      return;
    }

    setSelectedDocuments((prev) => [...prev, ...docFiles]);
    setShowDocumentPreview(true);
  };

  // Remove image
  const removeImage = (index) => {
    setSelectedImages((prev) => {
      const newImages = [...prev];
      URL.revokeObjectURL(newImages[index].preview);
      newImages.splice(index, 1);
      return newImages;
    });
  };

  // Remove document
  const removeDocument = (index) => {
    setSelectedDocuments((prev) => {
      const newDocs = [...prev];
      newDocs.splice(index, 1);
      return newDocs;
    });
  };

  // Start audio recording
  const startRecording = async () => {
    setRecordingTime(0);

    timerRef.current = setInterval(() => {
      setRecordingTime((prev) => prev + 1);
    }, 1000);

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);

      audioChunks.current = [];

      recorder.ondataavailable = (e) => {
        audioChunks.current.push(e.data);
      };

      recorder.onstop = () => {
        const audioBlob = new Blob(audioChunks.current, { type: "audio/webm" });
        setAudioBlob(audioBlob);
        stream.getTracks().forEach((track) => track.stop());
      };

      recorder.start();
      setMediaRecorder(recorder);
      setIsRecording(true);
    } catch (error) {
      console.error("Error accessing microphone:", error);
      SafeToast.error("Microphone access denied");
    }
  };

  // Stop audio recording
  const stopRecording = () => {
    clearInterval(timerRef.current);
    timerRef.current = null;
    if (mediaRecorder && isRecording) {
      mediaRecorder.stop();
      setIsRecording(false);
    }
  };

  const formatRecordingTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  };

  // Remove audio
  const removeAudio = () => {
    setAudioBlob(null);
  };

  // Upload file to server (example function)
  const uploadFile = async (file, type) => {
    const formData = new FormData();
    formData.append("files", file);

    try {
      const response = await ImageUpload(
        `/upload_image?userId=${userId}&type=${roleType}`,
        formData,
        true,
      );
      return response?.data?.[0]?.fileUrl || null;
    } catch (error) {
      console.error(`Error uploading ${type}:`, error);
      return null;
    }
  };

  const handleSendMessage = async () => {
    if (!receiverdeatils) {
      SafeToast.error("Please select a chat");
      return;
    }

    setLoading(true);

    try {
      const imageUrls = [];
      for (const image of selectedImages) {
        const url = await uploadFile(image.file, "image");
        if (url) imageUrls.push(url);
      }

      // Upload documents
      const documentUrls = [];
      for (const doc of selectedDocuments) {
        const url = await uploadFile(doc, "document");
        if (url) documentUrls.push(url);
      }

      // Upload audio
      let audioUrl = null;
      if (audioBlob) {
        audioUrl = await uploadFile(audioBlob, "audio");
      }

      const hasText = content.trim().length > 0;
      const hasImages = imageUrls.length > 0;
      const hasDocuments = documentUrls.length > 0;
      const hasAudio = !!audioUrl;

      if (!hasText && !hasImages && !hasDocuments && !hasAudio) {
        SafeToast.info("Message cannot be empty");
        setLoading(false);
        return;
      }

      // Prepare payload
      const payload = {
        sender_id: userId,
        sender_name: profile?.name,
        receiver_id: receiverdeatils.user_id,
        receiver_name: receiverdeatils.user_name,
        content: content.trim(),
        images: imageUrls,
        documents: documentUrls,
        audio: audioUrl ? [audioUrl] : [],
      };

      // Send message
      const data = await postWithTokenAPI(token, messages_create, payload);

      if (data?.data) {
        // Clear inputs
        setContent("");
        setSelectedImages([]);
        setSelectedDocuments([]);
        setAudioBlob(null);
        setShowImagePreview(false);
        setShowDocumentPreview(false);

        // Refresh messages
        HandleParicliteChnage();
        SafeToast.success("Message sent successfully");
      }
    } catch (error) {
      console.error("Error sending message:", error);
      SafeToast.error("Failed to send message");
    } finally {
      setLoading(false);
    }
  };

  // Clean up preview URLs
  useEffect(() => {
    return () => {
      selectedImages.forEach((image) => {
        URL.revokeObjectURL(image.preview);
      });
    };
  }, [selectedImages]);

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const DeleteChat = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This chat will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      const payload = {
        userId: userId,
        otherUserId: receiverdeatils?.user_id,
      };

      const res = await postWithTokenAPI(token, messages_delete, payload);

      if (res?.message) {
        SafeToast.success(res.message);
        HandleParicliteChnage();
      } else {
        SafeToast.error("Failed to delete chat");
      }
    } catch (error) {
      SafeToast.error("Something went wrong");
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    try {
      const payload = {
        messageIds: [id],
        userId: userId,
      };

      const res = await deleteWithTokenBodyAPI(
        token,
        messages_delete_multiple,
        payload,
      );

      if (res?.message) {
        SafeToast.success(res.message);
        HandleParicliteChnage(); // refresh / reload messages
      } else {
        SafeToast.error("Failed to delete message");
      }
    } catch (error) {
      SafeToast.error("Something went wrong");
      console.error(error);
    }
  };

  const handlePrint = () => {
    const printContent = document.querySelector(".chat-body");
    const printWindow = window.open("", "", "height=600,width=800");

    const senderName = profile?.name || "You";
    const receiverName = receiverdeatils?.user_name || "Receiver";

    printWindow.document.write(`
    <html>
      <head>
        <title>Chat History</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 30px;
            color: #000;
          }

          h2 {
            text-align: center;
            margin-bottom: 20px;
          }

          .message-row {
            margin-bottom: 16px;
            display: flex;
          }

         .received {
  display: flex;
  flex-direction: column;  

}

          .sent {
            justify-content: flex-end;
            text-align: right;
          }

          .message-bubble {
            background: none !important;
            padding: 0;
            max-width: 70%;
          }

          .sender-name {
            font-size: 13px;
           
          }

          .avatar-msg,
          .msg-info,
          svg,
          audio {
            display: none !important;
          }

          p {
            margin: 0 0 6px 0;
            font-size: 14px;
          }

          img {
            max-width: 300px;
            margin: 6px 0;
          }

          @media print {
            body {
              padding: 10px;
            }
          }
        </style>
      </head>
      <body>
        <h2>Chat Conversation</h2>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

    printWindow.document.close();


    /* ✅ Inject receiver name (received messages) */
    printWindow.document.querySelectorAll(".received").forEach((msg) => {
      const label = printWindow.document.createElement("div");
      label.className = "sender-name";
      label.innerText = receiverName;
      msg.prepend(label);
    });

    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  const [isPinned, setIsPinned] = useState(false);

  useEffect(() => {
    if (!chatList.length || !receiverdeatils?.user_id) return;

    const selectedChat = chatList.find(
      (chat) => chat.user_id === receiverdeatils.user_id,
    );
    if (selectedChat) {
      setIsPinned(selectedChat.isPinned);
    } else {
      setIsPinned(false);
    }
  }, [chatList, receiverdeatils?.user_id]);

  const handlePinToggle = async () => {
    try {
      const payload = {
        me: userId,
        friend: receiverdeatils?.user_id,
      };

      let res;

      if (isPinned) {
        res = await postWithTokenAPI(token, messages_unpin, payload);
        SafeToast.success("Chat unpinned");
      } else {
        // PIN
        res = await postWithTokenAPI(token, messages_pin, payload);
        SafeToast.success("Chat pinned");
      }

      if (res?.statusCode === 200) {
        setIsPinned(!isPinned);
        fetchChatList();
      }
    } catch (error) {
      SafeToast.error("Something went wrong");
      console.error(error);
    }
  };

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (messages.length) {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages.length]);

  return (
    <div className="full-message-page">
      <div className="message-topbar">
        <h3>Message</h3>
        <MoreVertical size={20} />
      </div>
      <div className="message-page">
        <aside className="chat-sidebar">
          <button className="my-chats-btn">My Chats</button>
          <h6 className="chat-list-title">Chat list</h6>
          <div className="chat-list">
            {chatList.map((list) => (
              <div
                key={list.user_id}
                className={`chat-item 
                ${activeChatId === list.user_id ? "active" : ""} 
                ${list.isPinned ? "pinned-chat" : ""}
            `}
                onClick={() => {
                  // HandleParicliteChnage();
                  setActiveChatId(list.user_id);
                  fetchChatList();
                  setReceiverdeatils(list);
                }}
              >
                <img
                  src={list.profile_img.logo || "/default-avatar.png"}
                  alt={list.user_name}
                  className="avatar-small"
                />

                <div className="chat-info">
                  <div className="chat-name-row">
                    <span className="chat-name">{list.user_name}</span>

                    {/* ⭐ Fav icon */}
                    {list.isPinned && <Star size={14} className="fav-icon" />}
                  </div>

                  {/* <span className="chat-last-message">{list.last_message}</span> */}
                </div>

                {list.unread_count > 0 && (
                  <span className="unread-badge">{list.unread_count}</span>
                )}
              </div>
            ))}
          </div>
        </aside>

        {/* Chat Area */}
        <main className="chat-container">
          <div className="chat-card">
            {activeChatId && (
              <header className="chat-header">
                <div className="header-left">
                  <ChevronLeft
                    className="header-left-arrow"
                    onClick={() => {
                      setMessages([]);
                      setActiveChatId(null);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                  <span>{receiverdeatils?.user_name}</span>
                </div>
                <div className="header-actions">
                  <Printer
                    size={18}
                    onClick={handlePrint}
                    style={{ cursor: "pointer" }}
                  />
                  <Star
                    size={20}
                    onClick={handlePinToggle}
                    className={`pin-icon ${isPinned ? "active" : ""}`}
                    style={{ cursor: "pointer" }}
                  />
                  <Trash2
                    size={18}
                    onClick={DeleteChat}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </header>
            )}

            <div className="chat-body">
              {messages.length === 0 ? (
                <div className="elegant-empty-state">
                  <div className="floating-bubbles">
                    <div className="bubble bubble-1"></div>
                    <div className="bubble bubble-2"></div>
                    <div className="bubble bubble-3"></div>
                  </div>

                  <div className="elegant-content">
                    <div className="message-icon-wrapper">
                      <svg
                        width="80"
                        height="80"
                        viewBox="0 0 80 80"
                        fill="none"
                      >
                        <circle
                          cx="40"
                          cy="40"
                          r="38"
                          fill="url(#gradient)"
                          fillOpacity="0.1"
                        />
                        <path
                          d="M24 28C24 24.6863 26.6863 22 30 22H50C53.3137 22 56 24.6863 56 28V52C56 55.3137 53.3137 58 50 58H40L32 64V58H30C26.6863 58 24 55.3137 24 52V28Z"
                          stroke="url(#gradient)"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <circle
                          cx="34"
                          cy="38"
                          r="2"
                          fill="url(#gradient)"
                          className="pulse"
                        />
                        <circle
                          cx="40"
                          cy="38"
                          r="2"
                          fill="url(#gradient"
                          className="pulse"
                          style={{ animationDelay: "0.2s" }}
                        />
                        <circle
                          cx="46"
                          cy="38"
                          r="2"
                          fill="url(#gradient)"
                          className="pulse"
                          style={{ animationDelay: "0.4s" }}
                        />
                        <defs>
                          <linearGradient
                            id="gradient"
                            x1="0%"
                            y1="0%"
                            x2="100%"
                            y2="100%"
                          >
                            <stop offset="0%" stopColor="#4F46E5" />
                            <stop offset="100%" stopColor="#7C3AED" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>

                    <h3 className="elegant-title">
                      The conversation begins here
                    </h3>
                    <p className="elegant-subtitle">
                      Send a message to start chat
                      {/* {receiverdeatils?.user_name || " your contact"} */}
                    </p>

                    <div className="typing-indicator">
                      <div className="typing-dot"></div>
                      <div className="typing-dot"></div>
                      <div className="typing-dot"></div>
                    </div>
                  </div>
                </div>
              ) : (
                messages.map((msg) => {
                  const isSent = msg.sender_id === userId;

                  // Check if message has attachments
                  const hasImages = msg.images && msg.images.length > 0;
                  const hasDocuments =
                    msg.documents && msg.documents.length > 0;
                  const hasAudio = msg.audio && msg.audio.length > 0;
                  const hasContent = msg.content?.trim().length > 0;

                  const hasAnyData =
                    hasContent || hasImages || hasDocuments || hasAudio;

                  return (
                    <div
                      key={msg._id}
                      className={`message-row ${isSent ? "sent" : "received"}`}
                    >
                      {!isSent && (
                        <img
                          src={msg?.sender_profile_img?.logo}
                          alt="avatar"
                          className="avatar-msg"
                        />
                      )}

                      {hasAnyData && (
                        <div className="message-bubble">
                          <p>{msg.sender_name}</p>
                          {msg.content && <p>{msg.content}</p>}
                          {hasImages && (
                            <div className="message-images">
                              {msg.images.map((img, idx) => (
                                <img
                                  key={idx}
                                  src={img}
                                  alt={`attachment-${idx}`}
                                  className="message-image"
                                  onClick={() => window.open(img, "_blank")}
                                />
                              ))}
                            </div>
                          )}

                          {hasDocuments && (
                            <div className="message-documents">
                              {msg.documents.map((doc, idx) => (
                                <a
                                  key={idx}
                                  href={doc}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="message-document"
                                >
                                  <File size={14} />
                                  <span>Document {idx + 1}</span>
                                </a>
                              ))}
                            </div>
                          )}

                          {/* Display audio */}
                          {hasAudio && (
                            <div
                              className={`message-audio ${isSent ? "sent" : "received"}`}
                            >
                              <div className="audio-bubble">
                                <div className="audio-icon">
                                  {" "}
                                  <Mic size={20} />
                                </div>

                                <audio controls className="audio-player">
                                  <source
                                    src={msg.audio[0]}
                                    type="audio/webm"
                                  />
                                  Your browser does not support audio.
                                </audio>
                              </div>
                            </div>
                          )}

                          <div className="msg-info">
                            <span className="time">
                              {formatTime(msg.createdAt)}
                            </span>

                            <div className="menu-wrapper">
                              {openMenuId === msg._id ? (
                                <X
                                  size={14}
                                  onClick={() => setOpenMenuId(null)}
                                  style={{ cursor: "pointer" }}
                                />
                              ) : (
                                <MoreVertical
                                  size={14}
                                  onClick={() => setOpenMenuId(msg._id)}
                                  style={{ cursor: "pointer" }}
                                />
                              )}

                              {openMenuId === msg._id && (
                                <div className="msg-dropdown">
                                  <div
                                    className="dropdown-item delete"
                                    onClick={() => {
                                      handleDelete(msg._id);
                                      setOpenMenuId(null);
                                    }}
                                  >
                                    Delete
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })
              )}
              <div ref={messagesEndRef} />
            </div>

            {/* File Previews */}
            {showImagePreview && selectedImages.length > 0 && (
              <div className="image-preview-container">
                <div className="preview-header">
                  <span>Images ({selectedImages.length})</span>
                  <button onClick={() => setShowImagePreview(false)}>
                    <X size={16} />
                  </button>
                </div>
                <div className="image-preview-grid">
                  {selectedImages.map((image, idx) => (
                    <div key={idx} className="preview-image-item">
                      <img src={image.preview} alt={`preview-${idx}`} />
                      <button
                        className="remove-preview-btn"
                        onClick={() => removeImage(idx)}
                      >
                        <X size={12} />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {showDocumentPreview && selectedDocuments.length > 0 && (
              <div className="document-preview-container">
                <div className="preview-header">
                  <span>Documents ({selectedDocuments.length})</span>
                  <button onClick={() => setShowDocumentPreview(false)}>
                    <X size={16} />
                  </button>
                </div>
                <div className="document-preview-list">
                  {selectedDocuments.map((doc, idx) => (
                    <div key={idx} className="preview-document-item">
                      <File size={16} />
                      <div className="document-info">
                        <span className="document-name">{doc.name}</span>
                        <span className="document-size">
                          {formatFileSize(doc.size)}
                        </span>
                      </div>
                      <button
                        className="remove-preview-btn"
                        onClick={() => removeDocument(idx)}
                      >
                        <X size={12} />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {audioBlob && (
              <div className="audio-preview-container">
                <div className="preview-header">
                  <span>Audio Recording</span>
                  <button onClick={removeAudio}>
                    <X size={16} />
                  </button>
                </div>
                <div className="audio-player-preview">
                  <Music size={20} />
                  <audio controls>
                    <source
                      src={URL.createObjectURL(audioBlob)}
                      type="audio/webm"
                    />
                  </audio>
                </div>
              </div>
            )}

            {activeChatId && (
              <footer className="chat-input-container">
                {/* Audio Recording Button */}
                <button
                  className={`input-icon ${isRecording ? "recording" : ""}`}
                  onClick={isRecording ? stopRecording : startRecording}
                  title={isRecording ? "Stop Recording" : "Start Recording"}
                >
                  {isRecording ? (
                    <StopCircle size={20} color="#ff4444" />
                  ) : (
                    <Mic size={20} />
                  )}
                </button>
                {isRecording && (
                  <span className="recording-timer">
                    {formatRecordingTime(recordingTime)}
                  </span>
                )}

                <div className="input-wrapper">
                  <input
                    type="text"
                    placeholder="Write message"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        handleSendMessage();
                      }
                    }}
                  />
                  <div className="input-actions">
                    {/* Document Upload */}
                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      multiple
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
                      onChange={handleDocumentSelect}
                    />
                    <button
                      onClick={() => fileInputRef.current.click()}
                      title="Attach Document"
                    >
                      <Paperclip size={18} />
                    </button>

                    {/* Image Upload */}
                    <input
                      type="file"
                      ref={imageInputRef}
                      style={{ display: "none" }}
                      multiple
                      accept="image/*"
                      onChange={handleImageSelect}
                    />
                    <button
                      onClick={() => imageInputRef.current.click()}
                      title="Attach Image"
                    >
                      <ImageIcon size={18} />
                    </button>
                  </div>
                </div>
                <button
                  className="send-btn"
                  onClick={handleSendMessage}
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Send"}
                  <Send size={14} style={{ marginLeft: "8px" }} />
                </button>
              </footer>
            )}
          </div>
        </main>
      </div>

    </div>
  );
};

export default MessageComponent;
